<template>
    <!--formatter:off-->
    <FocusLock>
        <div class="layer_wrap" :class="{parents: $isIamschoolParent}">
            <div class="layer_box" :style="layerBoxStyle">
                <div class="layer_content">
                    <em class="tit" v-if="title && !titleHtml">
                        <HangulWordWrapText :text="title"/>
                    </em>
                    <em class="tit" v-if="title && titleHtml" v-html="title"></em>
                    <p class="desc" v-if="desc && !descHtml">
                        <HangulWordWrapText :text="desc"/>
                    </p>
                    <p class="desc" v-if="desc && descHtml" v-html="desc"></p>
                </div>
                <!-- [D] 좌우 버튼의 크기가 다를 경우 type2 추가 -->
                <ul class="btn_area" :class="{type2: type === 'confirm'}">
                    <li v-if="type === 'confirm'"><button type="button" class="btn btn_gray" @click="onClickCancel">{{cancelText}}</button></li>
                    <li><button type="button" class="btn" @click="onClickOk">{{okText}}</button></li>
                </ul>
            </div>
        </div>
    </FocusLock>
    <!--formatter:on-->
</template>

<script>
import HangulWordWrapText from '@/common/components/HangulWordWrapText.vue';
import FocusLock from 'vue-focus-lock';
import modal from '@/common/mixins/modal.js';

export default {
    name: "ResponseAlertConfirm",
    components: {HangulWordWrapText, FocusLock},
    mixins: [
        modal,
    ],
    props: {
        type: {
            type: String,
            required: true,
        },

            okText: {
                type: String,
                default() {
                    return this.$t('common_confirm');
                }
            },

        cancelText: {
            type: String,
            default() {
                return this.$t('common_cancel');
            },
        },

        title: {
            type: String,
        },

        titleHtml: {
            type: Boolean,
            default: false,
        },

        desc: {
            type: String,
        },

        descHtml: {
            type: Boolean,
            default: false,
        },

        ok: {
            type: Function,
        },

        cancel: {
            type: Function,
        },

        width: {
            type: Number,
        },
    },

    computed: {
        layerBoxStyle() {
            return {
                width: `${this.width}px`,
            }
        },
    },

    methods: {
        onClickOk() {
            if (this.ok) {
                setTimeout(this.ok, 100);
            }

            this.close();
        },

            onClickCancel() {
                if (this.cancel) {
                    setTimeout(this.cancel, 100);
                }

                this.close();
            },

        }
    }
</script>

<style scoped>

</style>
